<div id="page-about-me">

    <div class="page-section-header about-header">
        <p>About Me</p>
    </div>

    <div class="page-section-container advent-pro-jaytee">
        <div class="page-section-row">

            <div class="page-info-container">
                <div class="page-info-container-title">
                    Name
                </div>
                <div class="page-info-container-name">
                    JT Washington
                </div>
            </div>

            <div class="page-info-container">
                <div class="page-info-container-title">
                    Country
                </div>
                <div class="page-info-container-name">
                    United States of America
                </div>
            </div>

            <div class="page-info-container">
                <div class="page-info-container-title">
                    Phone
                </div>
                <div class="page-info-container-name">
                    +1 (240) 630-1208
                </div>
            </div>

            <div class="page-info-container">
                <div class="page-info-container-title">
                    Email
                </div>
                <div class="page-info-container-name">
                    <p>jaytee.washington&#64;gmail.com</p>
                </div>
            </div>

        </div>

        <div class="page-section-row">
            
            <div class="page-info-container">
                <div class="page-info-container-title">
                    Education
                </div>
                <div class="page-info-container-name page-about-school">
                    <img src="assets/bowieState.png" alt="Bowie State Logo" />
                    <div class="page-program-school">
                        <p>Bowie State University</p>
                        <p>B.S - Computer Science</p>
                    </div>
                </div>
                <div class="page-info-container-name page-about-school">
                    <img src="assets/SyracuseOrange.png" alt="Syracuse Logo" />
                    <div class="page-program-school">
                        <p>Syracuse University</p>
                        <p>M.S - Computer Science</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
